import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { careerService, JobListing, CareerPageContent } from '@/services/career-service'
import { toast } from 'sonner'

export function useCareerPage() {
    const queryClient = useQueryClient()

    const contentQuery = useQuery({
        queryKey: ['career-content'],
        queryFn: careerService.getContent,
    })

    const updateContentMutation = useMutation({
        mutationFn: ({ data, translate }: { data: CareerPageContent; translate?: boolean }) =>
            careerService.updateContent(data, translate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['career-content'] })
            toast.success('Kariyer sayfası güncellendi')
        },
        onError: () => toast.error('Sayfa güncellenirken bir hata oluştu'),
    })

    return {
        ...contentQuery,
        updateContent: updateContentMutation.mutateAsync,
        isUpdating: updateContentMutation.isPending,
    }
}

export function useJobListings(status?: string) {
    const queryClient = useQueryClient()

    const query = useQuery({
        queryKey: ['job-listings', status],
        queryFn: () => careerService.getJobs(status),
    })

    const createMutation = useMutation({
        mutationFn: ({ data, translate }: { data: Partial<JobListing>; translate?: boolean }) =>
            careerService.createJob(data, translate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['job-listings'] })
            toast.success('İş ilanı oluşturuldu')
        },
        onError: () => toast.error('İlan oluşturulurken bir hata oluştu'),
    })

    const updateMutation = useMutation({
        mutationFn: ({ id, data, translate }: { id: string; data: Partial<JobListing>; translate?: boolean }) =>
            careerService.updateJob(id, data, translate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['job-listings'] })
            toast.success('İş ilanı güncellendi')
        },
        onError: () => toast.error('İlan güncellenirken bir hata oluştu'),
    })

    const deleteMutation = useMutation({
        mutationFn: (id: string) => careerService.deleteJob(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['job-listings'] })
            toast.success('İş ilanı silindi')
        },
        onError: () => toast.error('İlan silinirken bir hata oluştu'),
    })

    return {
        ...query,
        createJob: createMutation.mutateAsync,
        updateJob: updateMutation.mutateAsync,
        deleteJob: deleteMutation.mutateAsync,
        isMutating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
    }
}
